import { mapGetters } from 'vuex'

export default {
  name: 'ProfileMenu',

  computed: {
    ...mapGetters({
      userIsAdmin: 'userDataStore/userIsAdmin'
    }),

    username () {
      return this.$store.state.userDataStore.userId
    },
    keycloakExists () {
      return this.$keycloak
    },
    keycloakLogoutFn () {
      return this.$keycloak ? this.$keycloak.logoutFn : function () {}
    }
  }
}
